export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-ghost-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'horror', name: '惊悚', icon: 'ri-alert-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];